import React from 'react';
import ReactDOM from 'react-dom';
import 'assets/css/App.css';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import AuthLayout from 'layouts/auth';
import AdminLayout from 'layouts/admin';
import RtlLayout from 'layouts/rtl';
import { ChakraProvider } from '@chakra-ui/react';
import theme from 'theme/theme';
import { ThemeEditorProvider } from '@hypertheme-editor/chakra-ui';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import { Authenticator } from '@aws-amplify/ui-react';

import SignIn from 'views/auth/signIn';
import '@aws-amplify/ui-react/styles.css';

Amplify.configure(awsExports);

const App = () => (
  <ChakraProvider theme={theme}>
    <React.StrictMode>
      <ThemeEditorProvider>
        <Authenticator>
          {({ signOut, user }) => (
            <HashRouter>
              <Switch>
                {!user ? (
                  <Route path={`/auth/sign-in`} component={SignIn} />
                ) : (
                  <>
                    <Route path={`/auth/sign-in`} component={SignIn} />
                    <Route path={`/admin`} component={AdminLayout} />
                    <Route path={`/rtl`} component={RtlLayout} />
                    <Redirect from='/' to='/admin/default' />
                  </>
                )}
              </Switch>
            </HashRouter>
          )}
        </Authenticator>
      </ThemeEditorProvider>
    </React.StrictMode>
  </ChakraProvider>
);

ReactDOM.render(<App />, document.getElementById('root'));
